import { useWorkspace } from '@/hooks/workspace';
import {
  Button,
  Flex,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import * as BsIcons from 'react-icons/bs';
import * as TbIcons from 'react-icons/tb';

import { LinkButton } from './styles';

interface ExternalLinksProps {
  isMobile?: boolean;
}

export function ExternalLinks({ isMobile }: ExternalLinksProps) {
  const { workspaceData } = useWorkspace();

  const links = useMemo(() => workspaceData?.links || [], [workspaceData]);

  const content = useMemo(() => {
    if (isEmpty(links)) {
      return null;
    }

    if (links.length > 3 || isMobile) {
      return (
        <Menu orientation="horizontal">
          <MenuButton
            as={Button}
            color="gray.800"
            bg="white"
            border="none"
            width={!isMobile ? '36px' : 'full'}
            height={!isMobile ? '36px' : 'auto'}
            borderRadius={!isMobile ? 'full' : 'none'}
          >
            <Flex alignItems="center" gap="0.70rem">
              <TbIcons.TbLink size={20} />
              {isMobile && <Text fontSize="md">Links externos</Text>}
            </Flex>
          </MenuButton>
          <MenuList zIndex={100}>
            {links.map((link) => {
              const Icon = TbIcons?.[link.icon] || BsIcons?.[link.icon];
              return (
                <MenuItem key={link.title}>
                  <Link href={link.url} target="_blank" color="gray.800">
                    <Flex alignItems="center" gap="0.75rem">
                      {Icon && <Icon size={20} />}
                      <Text fontSize="md">{link.title}</Text>
                    </Flex>
                  </Link>
                </MenuItem>
              );
            })}
          </MenuList>
        </Menu>
      );
    }

    return (
      <Flex
        direction="column"
        borderBottom="1px"
        borderBottomColor="gray.200"
        paddingBottom="3"
        gap="3"
      >
        {links.map((link) => {
          const Icon =
            TbIcons?.[link.icon] ||
            BsIcons?.[link.icon] ||
            TbIcons.TbExternalLink;
          return (
            <Tooltip label={link.title} placement="right">
              <LinkButton color="gray.800" href={link.url} target="_blank">
                <Icon size={20} />
              </LinkButton>
            </Tooltip>
          );
        })}
      </Flex>
    );
  }, [links, isMobile]);

  return content;
}
